var m = require('mithril');
var Model = require('../../libs/Model');
var formGroup = require('../../components/formGroup');

var column = Object.create(Model);

column.name = 'Column';
column['@class'] = 'Column';
column.url = 'column';

column.fields = {
  out: {
    validators : {
      presence: true
    }
  },
  in: {
    validators: {
      presence: true
    }
  },
  name: {
    default: null,
    validators : {
      presence : true,
      length: {minimum: 1, maximum: 80, default: ''}, 
    }
  },
  chartType: {
    default: 'line'
  },
  min: {
    default: 0
  },
  max: {
    default: 100
  },
  scale: {
    default: undefined
  },
  index: {},
  graphicComponent: {
    default: 'text',
  }
};

column.view = function (ctrl) {
  return  m('form', {role:'form'}, [
    column.errorView(),
    m(formGroup, [
      m('name', {for:'dashboard-name-input'}, 'Name'),
      m('input.form-control', {
        id:'dashboard-name-input', 
        type:'text', 
        onchange: function(ev){column.form.name(ev.target.value)},
        value: column.form.name(),
      })
    ])
  ]);
}

module.exports = column;
